import React, {useState} from "react";
import Container from "react-bootstrap/Container";
import {Nav} from "react-bootstrap";
import "@fortawesome/fontawesome-svg-core/styles.css";
import {HashLink as Link} from "react-router-hash-link";
import YouTube from "react-youtube";
import {useDispatch} from "react-redux";
import {videoAccessLog} from "../../actions/videoAccessLog";
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Box from "@mui/material/Box";
import Card from "react-bootstrap/Card";
import {CardContent} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";

const SelectOrbits = () => {

    const [show, setShow] = useState(true);
    const label = { inputProps: { 'aria-label': 'Select Orbit' } };

    return (
        <div>
            <Container>
                <div className="col-10 m-auto selectOrbit">
                    <div className="whiteBackground floatLeft clearLeft legosNewBuild">
                        {/*They haven't selected which method they want to do so I just put both for the short term*/}
                        <Alert variant="primary" onClose={() => setShow(false)} dismissible>
                            <Alert.Heading>Welcome Please Select an Orbit</Alert.Heading>
                            <p>
                                Duis mollis, est non commodo
                                luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.
                                Cras mattis consectetur purus sit amet fermentum. Duis mollis, est non commodo
                                luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.
                                Cras mattis consectetur purus sit amet fermentum.
                                Duis mollis, est non commodo
                                luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.
                                Cras mattis consectetur purus sit amet fermentum. Duis mollis, est non commodo
                                luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.
                                Cras mattis consectetur purus sit amet fermentum.
                            </p>
                        </Alert>
                        {/*<Card className="w-100" variant="outlined">*/}
                        {/*    <CardContent>*/}
                        {/*    <h1 className="text-dark">Welcome Please Select an Orbit</h1>*/}
                        {/*    <p>Duis mollis, est non commodo*/}
                        {/*        luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.*/}
                        {/*        Cras mattis consectetur purus sit amet fermentum. Duis mollis, est non commodo*/}
                        {/*        luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.*/}
                        {/*        Cras mattis consectetur purus sit amet fermentum.*/}
                        {/*        Duis mollis, est non commodo*/}
                        {/*        luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.*/}
                        {/*        Cras mattis consectetur purus sit amet fermentum. Duis mollis, est non commodo*/}
                        {/*        luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.*/}
                        {/*        Cras mattis consectetur purus sit amet fermentum.</p>*/}
                        {/*    </CardContent>*/}
                        {/*</Card>*/}

                        I imagine this will run in a loop. I imagined that we might show an active state orbit.
                        But this wouldn't apply the first time they come into the site. However if they clicked the nav item to get
                        back an active orbit would populate. Styling is not finalized, but should be good enough to get going.
                        <div className="orbitSelection">
                            <div className="selectAbleOrbit active"><Checkbox {...label} defaultChecked /><Nav.Link href="" className="text-dark">Siteman ENT</Nav.Link></div>
                            <div className="selectAbleOrbit"><Checkbox {...label} /><Nav.Link href="" className="text-dark">Siteman Pancreatic</Nav.Link></div>
                            <div className="selectAbleOrbit"><Checkbox {...label} /><Nav.Link href="" className="text-dark">Wash U Living Well Center</Nav.Link></div>
                            <div className="selectAbleOrbit"><Checkbox {...label} /><Nav.Link href="" className="text-dark">Wash U Injection Support</Nav.Link></div>
                            <div className="selectAbleOrbit"><Checkbox {...label} /><Nav.Link href="" className="text-dark">Bloodpressure Support</Nav.Link></div>
                        </div>
                        <div className="buttonContainer loginButtonContainer">
                            <Button
                                className="loginUIComp"
                                type="submit"
                                variant="contained"
                                color="primary"
                            >
                                Change Orbit
                            </Button>
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    );

};

export default SelectOrbits;
